// React & React Hooks
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Third-party libraries
import { Box, Card, Stack, Typography } from "@mui/material";

// Constants
import dataConstant from "../../constants/dataConstants";
import urlConstant from "../../constants/urlConstants";

// Services / utilities
import { httpGet } from "../../services/commonService";

// Custom components
import SnackState from "../../shared-components/snackbar/snackState";
import CommonSnackBar from "../../shared-components/snackbar/commonSnackbar";

function TermsAndConditions() {
  const [state, setState] = useState({
    legalDocDet: {
      id: 0,
      documentName: "",
      documentType: "",
      countryId: 0,
      languageId: 0,
      documentContent: "",
      isConfirmationRequire: true,
      isActive: true,
    },
  });

  const [snack, closeSnack, showSnackbar] = SnackState();
  const { prevPage } = useParams();

  useEffect(() => {
    let documentName, documentType;

    if (
      prevPage === dataConstant.termsAndConditionPreviousPage.becomeAnAffiliate
    ) {
      documentName = dataConstant.AffiliateTermsAndConditions.DocumentName;
      documentType = dataConstant.AffiliateTermsAndConditions.DocumentType;
    } else if (
      prevPage === dataConstant.termsAndConditionPreviousPage.enrollmentForm
    ) {
      documentName =
        dataConstant.repPoliciesAndProcedureDocumentDet.DocumentName;
      documentType =
        dataConstant.repPoliciesAndProcedureDocumentDet.DocumentType;
    } else if (
      prevPage === dataConstant.termsAndConditionPreviousPage.privacyPolicy
    ) {
      documentName = dataConstant.PrivacyPolicy.DocumentName;
      documentType = dataConstant.PrivacyPolicy.DocumentType;
    } else if (
      prevPage ===
      dataConstant.termsAndConditionPreviousPage.IBOtermsAndConditions
    ) {
      documentName = dataConstant.IBOTermsAndConditions.DocumentName;
      documentType = dataConstant.IBOTermsAndConditions.DocumentType;
    } else if (
      prevPage === dataConstant.termsAndConditionPreviousPage.refundPolicy
    ) {
      documentName = dataConstant.RefundPolicy.DocumentName;
      documentType = dataConstant.RefundPolicy.DocumentType;
    } else if (
      prevPage === dataConstant.termsAndConditionPreviousPage.termsOfUse
    ) {
      documentName = dataConstant.TermsOfUse.DocumentName;
      documentType = dataConstant.TermsOfUse.DocumentType;
    } else if (
      prevPage ===
      dataConstant.termsAndConditionPreviousPage.memberTermsAndConditions
    ) {
      documentName = dataConstant.IBOTermsAndConditions.DocumentName;
      documentType = dataConstant.IBOTermsAndConditions.DocumentType;
    }

    getLegalDocumentDetailByTypeAndName(documentName, documentType);
  }, []);

  const getLegalDocumentDetailByTypeAndName = async (Name, Type) => {
    const getLegalDocumentDetailByTypeAndNameURL = `${urlConstant.LegalDocument.LegalDocumnetDetailByTypeAndName}?DocumentName=${Name}&DocumentType=${Type}`;
    await httpGet(getLegalDocumentDetailByTypeAndNameURL, true)
      .then((response) => {
        if (response.Value.Status === dataConstant.APIResponseStatus.Success) {
          const responseData = response.Value.Data;
          const legalDocDet = {
            id: responseData.Id,
            documentName: responseData.DocumentName,
            documentType: responseData.DocumentType,
            countryId: responseData.CountryId,
            languageId: responseData.LanguageId,
            documentContent: responseData.DocumentContent,
            isConfirmationRequire: responseData.IsConfirmationRequire,
            isActive: responseData.IsActive,
          };
          state.legalDocDet = legalDocDet;
          setState((prevState) => ({
            ...prevState,
            legalDocDet,
          }));
        } else {
          const errorMessage = response.Value?.Message;
          showSnackbar(errorMessage, "error");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <Box sx={{ m: 4, p: { xs: 2, md: 4 } }}>
      <Card
        sx={(theme) => ({
          p: "20px",
          backgroundImage: theme.palette.background.cardGradient,
          border: "1px solid var(--headerbg)",
          borderRadius: "20px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
          flex: "1",
          maxWidth: "100%",
          minWidth: { xs: "auto", sm: "400px" },
        })}
      >
        <Stack spacing={2} sx={{ p: 2 }}>
          <Typography
            variant="h4"
            color="primary"
            fontWeight="bold"
            dangerouslySetInnerHTML={{ __html: state.legalDocDet.documentName }}
          />
          <Box
            sx={{ color: "text.primary", lineHeight: 1.6 }}
            dangerouslySetInnerHTML={{
              __html: state.legalDocDet.documentContent,
            }}
          />
        </Stack>
      </Card>
      <CommonSnackBar snackObj={snack} closeSnack={closeSnack} buttonProp />
    </Box>
  );
}

export default TermsAndConditions;